import { render, staticRenderFns } from "./cxSlider2.vue?vue&type=template&id=210d9f46&scoped=true"
import script from "./cxSlider2.vue?vue&type=script&lang=js"
export * from "./cxSlider2.vue?vue&type=script&lang=js"
import "./cxSlider2.vue?vue&type=style&index=0&id=210d9f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d9f46",
  null
  
)

export default component.exports